export default  {
            "AUTH" : "https://bzzprqlcic.execute-api.ap-south-1.amazonaws.com"
}

